import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,_vm._b({class:_vm.schema['x-class'],staticStyle:{"text-transform":"none"},attrs:{"disabled":_vm.disabled,"tile":""},on:{"click":_vm.onClick}},'v-btn',_vm.schema['x-props'],false),[(_vm.iconFlag)?_c(VIcon,{attrs:{"left":"","color":_vm.iconColor,"size":_vm.iconSize}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }